import { Component, computed, OnInit, Signal } from '@angular/core'
import { NaturalStoneCartLine } from '../../../interfaces/natural-stone/natural-stone-cart'
import { NaturalStoneService } from '../../../services/natural-stone.service'
import { TranslateModule } from '@ngx-translate/core'
import { AlertComponent } from '@components/alert/alert.component'
import { NgClass, NgForOf } from '@angular/common'
import { NaturalStoneCartLineComponent } from '../natural-stone-cart-line/natural-stone-cart-line.component'

@Component({
  selector: 'app-natural-stone-finalize-preorder-cart',
  standalone: true,
    imports: [
        TranslateModule,
        AlertComponent,
        NgForOf,
        NaturalStoneCartLineComponent,
        NgClass
    ],
  templateUrl: './natural-stone-finalize-preorder-cart.component.html',
  styleUrl: './natural-stone-finalize-preorder-cart.component.scss'
})
export class NaturalStoneFinalizePreorderCartComponent implements OnInit{

    cart: Signal<NaturalStoneCartLine[]>

    constructor(private naturalStoneService: NaturalStoneService) {
    }

    ngOnInit() {
        this.cart = computed(() => this.naturalStoneService.cart())
    }

    getTotalInCart(){
        return this.naturalStoneService.getTotalInCart();
    }
}
